import React, { useState, useEffect, useRef } from "react";
import Avatar from "@mui/material/Avatar";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { ReactComponent as Close } from "../../../assets/images/teamclose.svg";
import { ListCoRoleName } from "../../../store/features/ListCoUserByRole";
import { assignAgent } from "../../../store/features/assignAgent";
import { assignedAgent } from "../../../store/features/assignedAgent";
import SearchInput from "../../common/SearchInputField";
import { CircularProgress, Box, Skeleton } from "@mui/material";
import { createAppSocket, emitAgentSetup } from '../../../api/createAppSocket';
import { useNavigate } from "react-router-dom";
import { chracterPosition } from "../../../utils/index";
import { colorCodesForAvatar } from "../../../constants/index";
import NoSearch from "../../common/NoSearch";
import { getLiveChatBasePath } from "../../../utils/liveChatPath";

// Skeleton component for agent items
const AgentItemSkeleton = () => (
  <div style={{ padding: '8px 0px' }} className="ChatPopup-Darleen-Container">
    <Skeleton variant="circular" width={40} height={40} />
    <div style={{ marginLeft: '12px', flex: 1 }}>
      <Skeleton variant="text" width="60%" height={20} />
      <Skeleton variant="text" width="40%" height={16} />
    </div>
  </div>
);




function AssignChatPopUp(props) {
  const [assignedList, setAssignedList] = useState();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [assignLoading, setAssignLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const socketRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.loginToken);

  const {
    setAssignChatPopup,
    selectUser,
    setSelectUser,
    assignChat,
    setChatSideBar,
    onRoomAssigned,
  } = props;

  // Socket setup
  useEffect(() => {
    socketRef.current = createAppSocket();
    emitAgentSetup(socketRef.current);

    return () => {
      // socketRef.current.disconnect();
    };
  }, [userData?.response?.user._id]);

  // Single data loading function
  useEffect(() => {
    loadAllData();
  }, []);

  const loadAllData = async () => {
    setIsLoading(true);

    try {
      // First, get the assigned agent
      const assignedAgentResponse = await dispatch(
        assignedAgent({ id: selectUser.id })
      );

      let currentAssignedAgent = null;

      if (assignedAgentResponse?.payload?.status === 200) {
        currentAssignedAgent = assignedAgentResponse.payload.assignedAgent;
        setAssignedList(currentAssignedAgent);
      }

      // Then, get all available agents
      const availableAgentsResponse = await dispatch(
        ListCoRoleName({ name: "agent,admin,admin_with_billing" })
      );

      if (availableAgentsResponse?.payload?.status === 200) {
        const rawData = availableAgentsResponse.payload.data || [];

        if (rawData.length > 0) {
          const filteredData = rawData
            .filter((item) => {
              return item.accept_chat &&
                (!currentAssignedAgent || currentAssignedAgent._id !== item._id);
            })
            .map((item) => ({
              id: item._id,
              img: item.agent_image,
              name: item.full_name,
              description: "No active chats",
            }));

          setData(filteredData);
          setFilteredData(filteredData);
        } else {
          setData([]);
          setFilteredData([]);
        }
      } else if (availableAgentsResponse?.payload?.status === 401) {
        toast.error("Login Expired. Please login and try again.");
        navigate("/login");
      } else {
        throw new Error("Failed to load available agents");
      }

    } catch (error) {
      console.error("Error loading data:", error);
      toast.error("Some error occurred. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAgentClick = (id) => {
    setSelectedAgent(id);
  };

  const handleAssignAgent = async () => {
    const listCoUserList = dispatch(
      assignAgent({
        requestHeaders: {
          mainUserId: selectedAgent,
          roomId: selectUser?.id,
        },
      })
    );
    listCoUserList
      .then(async (data) => {
        if (!data.payload) {
          toast.error("Some Error Occured. Please try again later");
        } else if (data?.payload?.success) {
          toast.success("Chat Assigned Successfully.");
          if (selectUser?.is_unAssigned) {
            onRoomAssigned?.(selectUser.id, { claimForSelf: false });
          }
          assignChat();
          setAssignChatPopup(false);
          setChatSideBar(false);
          socketRef.current.emit("create-room");
          socketRef.current.emit("self-assign", selectUser.id);
          navigate(getLiveChatBasePath(window.location.pathname));
          setSelectUser(null);
        } else {
          toast.error(data?.payload?.message);
        }
      })
      .catch(async (error) => {
        toast.error(error);
      });
  };

  const getAssignedAgent = async () => {
    const listCoUserList = dispatch(
      assignedAgent({
        id: selectUser.id,
      })
    );
    listCoUserList
      .then(async (data) => {
        if (typeof data.payload === "undefined") {
          toast.error("Some Error Occured. Please try again later.");
        } else if (data?.payload?.status === 200) {
          const { assignedAgent } = data?.payload;
          console.log("assignedAgent=========================", assignedAgent);
          setAssignedList(assignedAgent);
          setAssignLoading(false);
        } else {
          toast.error("Login Expired. Please login  and try again.");
          setAssignLoading(false);
        }
      })
      .catch(async (error) => {
        toast.error(error);
        setAssignLoading(false);
      });
  };

  const handleSearch = () => {
    RoleCoUserByID();
  };

  useEffect(() => {
    getAssignedAgent();
  }, []);

  const handleSearchInputChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredResults = data.filter((row) =>
      row.name.toLowerCase().includes(query)
    );
    setFilteredData(filteredResults);
  };

  const isTranferDisabled = selectedAgent == null;

  return (
    <>
      <div className="overlay" style={{zIndex: 50}}/>
      <div className="Assign-PopUp-Container" style={{zIndex: 51}}>
        <div className="Team-PopUp-Header">
          <p className="PopUp-Text01">Assign Chat</p>
          <p className="PopUp-Text02" onClick={() => setAssignChatPopup(false)}>
            <Close />
          </p>
        </div>
        <div className="ChatAgent-Main-Container-Assign">
          {/* Comments preserved as in original */}
        </div>

        {/* Search Input with skeleton */}

        <div className="SearchChat-Popup-Assign">
          <SearchInput
            title=""
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchInputChange}
          />
        </div>


        {/* Content with skeleton loading */}
        {isLoading ? (
          <div className="AgentsList">
            {/* Show skeleton for assigned agent */}
            <AgentItemSkeleton />
            <hr
              style={{
                backgroundColor: "#F1F3F5",
                height: "1px",
                border: "none",
                margin: "8px 0",
              }}
            />
            {/* Show skeleton for available agents */}
            {[...Array(3)]?.map((_, index) => (
              <AgentItemSkeleton key={index} />
            ))}
          </div>
        ) : (
          <>
            {/* Show assigned agent if exists */}
            {assignedList?.full_name && (
              <>
                <div className="AgentsList">
                  <div style={{ padding: '8px 0px' }} className="ChatPopup-Darleen-Container">
                    <p>
                      {assignedList?.agent_image ? (
                        <img
                          src={assignedList?.agent_image}
                          alt="users logo"
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                          }}
                        />
                      ) : (
                        <Avatar
                          sx={{
                            bgcolor:
                              colorCodesForAvatar[
                              chracterPosition(
                                assignedList?.full_name
                                  ?.substring(0, 1)
                                  ?.toUpperCase()
                              )
                              ],
                          }}
                        >
                          {assignedList?.full_name?.substring(0, 1)?.toUpperCase()}
                        </Avatar>
                      )}
                    </p>
                    <div>
                      <p className="Albert-text">{assignedList?.full_name}</p>
                      <p className="No-activetext">Assigned</p>
                    </div>
                  </div>
                </div>
                {filteredData?.length !== 0 && <hr
                  style={{
                    backgroundColor: "#F1F3F5",
                    height: "1px",
                    border: "none",
                    margin: "8px 0",
                  }}
                />}
              </>
            )}

            {/* Show available agents list */}
            <div style={{ maxHeight: '200px', overflowY: 'auto', padding: 0 }} className="AgentsList">
              {searchQuery && filteredData?.length === 0 ? (
                <NoSearch
                  title="No Active Agent Found"
                  description="Clear your search and try again."
                  titleFontSize={14}
                  descriptionFontSize={12}
                />
              ) : (
                filteredData.map((item, index) => (
                  <div
                    style={{ padding: selectedAgent === item.id ? '8px' : '8px 0px' }}
                    className={`ChatPopup-Darleen-Container ${selectedAgent === item.id ? "selected" : ""
                      }`}
                    key={index}
                    onClick={() => handleAgentClick(item.id)}
                  >
                    <p>
                      {item.img ? (
                        <img
                          src={item.img}
                          alt="users logo"
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                          }}
                        />
                      ) : (
                        <Avatar
                          sx={{
                            bgcolor:
                              colorCodesForAvatar[
                              chracterPosition(
                                item?.name?.substring(0, 1)?.toUpperCase()
                              )
                              ],
                          }}
                        >
                          {item?.name?.substring(0, 1)?.toUpperCase()}
                        </Avatar>
                      )}
                    </p>
                    <div>
                      <p className="Albert-text">{item?.name}</p>
                      <p className="No-activetext">{item?.description}</p>
                    </div>
                  </div>
                ))
              )}
            </div>
          </>
        )}

        <div className="AssignChat-footer">
          <p className="Add-PrivateChat">{/* Add Private Chat */}</p>
          <button
            className="AddTansfer"
            onClick={handleAssignAgent}
            disabled={isTranferDisabled || isLoading}
          >
            Transfer
          </button>
        </div>
      </div>
    </>
  );
}

export default AssignChatPopUp;